var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.577 1.282H9.94l1.026.043.983.086.94.213.899.214.811.342.77.342.726.428.684.47.6.513.598.556.513.598.47.641.384.684.385.685.3.726.256.727L33.577 0l4.83 3.249-10.344 6.668 1.667 1.111 10.43-6.625 4.488 2.992-10.302 6.797L36.1 15.26l10.47-6.668v-7.31h7.694v14.576h6.84v6.84H46.57v-7.01l-12.95 8.334-13.21-8.933-.257.77-.256.726-.385.727-.385.727-.47.641-.513.642-.555.598-.642.513-.64.513-.77.427-.77.385-.855.342-.898.256-.94.171-.983.129-1.069.042H.577V1.282zM7.93 7.993h2.009l.897.086.727.256.641.385.556.513.385.598.3.642.17.727.043.726-.043.727-.17.727-.3.641-.428.599-.513.513-.64.385-.77.256-.855.086h-2.01V7.993zm55.099-6.71h7.737v14.575h6.797v6.84H63.029V1.282z",
    fill: "#B9B9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDell);
export default __webpack_public_path__ + "static/media/dell.63511b65fd20e51ab93174aa95e706a9.svg";
export { ForwardRef as ReactComponent };